//Include Both Helper File with needed methods

import {
  
    postSupportQuery,
} from "../../../helpers/fakebackend_helper";



import { createAsyncThunk } from "@reduxjs/toolkit";


export const supportRaiseQueryThunk = createAsyncThunk("supportRaiseQueryThunk", async ({ body, token }, { rejectWithValue } ) => {
  try {
    const response = await postSupportQuery(body, token);
    return response;
  } catch (error) {
    // Properly pass the error structure to the reducer
    return rejectWithValue({
      code: error.data?.code || error.code,
      message: error.message,
      data: error.data
    });
  }
});










